/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Html5QrcodePlugin from './Html5QrcodePlugin';
import 'assets/style/qr-scanner.css';
import Avatar from 'components/base/Avatar';
import Icon from 'components/icon';
import Button from 'components/base/Button';
import gsap from 'gsap';
const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
  & .modal-dialog {
    max-width: 575px !important;
    /* min-height: 300px; */
    margin-right: auto;
    margin-left: auto;
  }
`;

const ScanQrCodeModal = ({
  show,
  handleClose,
  setUPIData,
  driverName,
  isDifferentName
}) => {
  const [qrScanned, setQrScanned] = useState(false);
  const [result, setResult] = useState(null);
  const [isInvalidQr, setIsInvalidQr] = useState(false);
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);

  // create a function for add stagger animation to result (reveal up one by one) using gsap
  const addStaggerAnimation = () => {
    const tl = gsap.timeline();
    // if (!isAnimationComplete) {
    // }
    tl.fromTo(
      '.revealResult',
      {
        opacity: 0,
        y: 50,
        ease: 'power1.easeIn'
      },
      {
        opacity: 1,
        y: 0,
        ease: 'power1.easeIn',
        stagger: 0.5
        // onComplete: () => {
        //   setIsAnimationComplete(true);
        // }
      }
    );
  };

  useEffect(() => {
    addStaggerAnimation();
  }, [qrScanned]);

  // create a function for add animation to scanner for hide (zoom out animation and in transform origin center) and remove on completion

  const addZoomOutAnimation = () => {
    const tl = gsap.timeline();
    tl.fromTo(
      '.scannerAnimation',
      {
        scale: 1,
        ease: 'power1.easeIn'
      },
      {
        scale: 0,
        ease: 'power1.easeIn'
      }
    );
  };

  const handleQRCodeScanned = async (decodedText, decodedResult) => {
    if (!qrScanned) {
      if (decodedText?.includes('upi')) {
        const upiUri = new URL(decodedText);
        const searchParams = upiUri.searchParams;
        setResult({
          payeeName: searchParams.get('pn'),
          payeeId: searchParams.get('pa')
        });
        // addZoomOutAnimation();
        setQrScanned(true);
        // setTimeout(() => {
        //   addStaggerAnimation();
        // }, 100);
      } else {
        setIsInvalidQr(true);
      }
    }
    // Handle the scanned QR code results (e.g., display them, perform an action)
    console.log('Scanned QR code:', decodedText, decodedResult);

    await new Promise(resolve => setTimeout(resolve, 1000));
  };

  const handleRescan = () => {
    setQrScanned(false);
    setIsInvalidQr(false);
    setIsAnimationComplete(false);
    setResult(null);
  };

  const handleCloseButton = () => {
    handleClose();
    handleRescan();
  };

  const handleSelectUpi = () => {
    const { payeeName, payeeId } = result;
    const regex = /^[a-zA-Z0-9.\s]+$/;
    if (payeeName.match(regex)) {
      setUPIData({
        payeeName: payeeName,
        payeeId: payeeId
      });
    } else {
      setUPIData({
        payeeName: driverName,
        payeeId: payeeId
      });
    }

    handleCloseButton();
  };
  return (
    <CustomModal
      centered
      size="sm"
      fullscreen={'sm-down'}
      // dialogClassName="modal-600px"
      show={show}
      onHide={handleCloseButton}
      backdrop="static"
      // style={{ overflow: 'hidden' }}
      keyboard={false}
    >
      <Modal.Header
        className="border-0 position-relative pb-0 end-0 dark__text-white"
        closeButton
      >
        <div className="d-flex align-items-center flex-column me-2">
          <Avatar size="xl" variant="name">
            <i className="fas fa-qrcode"></i>
            <Icon icon={'streamline:qr-code'} />
          </Avatar>
        </div>
        Scan UPI Code
      </Modal.Header>
      <Modal.Body className="pt-3 overflow-hidden position-relative">
        <div
          className="d-flex justify-content-center "
          style={{ height: '500px' }}
        >
          <div
            className="w-100 h-100 scannerAnimation mt-4"
            style={{
              transformOrigin: 'center',
              display: qrScanned ? 'none' : 'block'
            }}
          >
            {isInvalidQr ? (
              <p className="fs-10 text-danger my-1">Invalid QR Code</p>
            ) : null}
            <Html5QrcodePlugin
              fps={10}
              qrScanned={qrScanned}
              qrbox={250}
              disableFlip={false}
              qrCodeSuccessCallback={handleQRCodeScanned}
            />
          </div>
          {!qrScanned ? (
            <></>
          ) : (
            // <div
            //   className="w-100 h-100 scannerAnimation mt-4"
            //   style={{ transformOrigin: 'center' }}
            // >
            //   {isInvalidQr ? (
            //     <p className="fs-10 text-danger my-1">Invalid QR Code</p>
            //   ) : null}
            //   <Html5QrcodePlugin
            //     fps={10}
            //     qrScanned={qrScanned}
            //     qrbox={250}
            //     disableFlip={false}
            //     qrCodeSuccessCallback={handleQRCodeScanned}
            //   />
            // </div>
            <div className="mt-4">
              <div className="d-flex align-items-center flex-column mb-5 text-success revealResult">
                <Icon
                  icon={'line-md:confirm-circle-twotone'}
                  fontSize="150px"
                />
                <h4 className="h4 text-success">QR Code Scanned</h4>
              </div>
              <div className="px-2 px-sm-5 mt-5">
                <div className="p-3 rounded-2 w-100 bg-primary-100 revealResult">
                  <p className="mb-2">
                    <b>Payee UPI - </b>
                    <span>{result?.payeeId}</span>
                  </p>
                  <p className="mb-0">
                    <b>Payee Name - </b>
                    <span>{result?.payeeName}</span>
                  </p>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-2 mt-3 revealResult">
                  <Button onClick={handleRescan} variant="phoenix-secondary">
                    Scan Another
                  </Button>
                  <Button onClick={handleSelectUpi} variant="phoenix-primary">
                    Select UPI
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </CustomModal>
  );
};

export default ScanQrCodeModal;
